/*
 * @overview: 实现对 XMLHttpRequest 和 fetch 的拦截器功能，用于监听请求的发送和响应过程，以便在出现错误时进行上报。
 * @Created by: zhuyikai
 * @Copyright: Copyright © 2020 找我婚礼. All rights reserved.
 * @Date: 2023-03-29 10:19:21
 */

import { tracker, options } from "../core";
import { EVENTTYPES, ERRORTYPES } from "../const";

/**
 * 监听xhr, 重写了 XMLHttpRequest 的 send 方法
 * 添加事件监听器，用于在请求的不同阶段（load、error、abort、catch）触发对应的事件处理函数，
 * 对请求的状态、持续时间、响应数据等进行记录和上报.
 */
export function injectXHR() {
  let XMLHttpRequest = window.XMLHttpRequest;
  const oldOpen = XMLHttpRequest.prototype.open;
  // 重写open方法，添加拦截器功能
  XMLHttpRequest.prototype.open = function (method, url, async) {
    // 不拦截白名单请求，防止死循环
    var InWhiteList = options.whiteList.some((item) => url.includes(item));
    if (!InWhiteList) {
      this.log = { method, url, async };
    }
    return oldOpen.apply(this, arguments);
  };

  let oldSend = XMLHttpRequest.prototype.send;
  let startTime;
  XMLHttpRequest.prototype.send = function (body) {
    if (this.log) {
      startTime = Date.now(); // 发送前时间
      let handler = (type) => (e) => {
        let duration = Date.now() - startTime; // 持续时间
        let status = this.status;
        let statusText = this.statusText;
        // 请求成功不上报
        if (status == 200 || status == 204) return;
        if (Date.now() - options.apiSending < 3000) return;
        tracker.send({
          type: EVENTTYPES.XHR,
          errorType: ERRORTYPES.FETCH_ERROR,
          eventType: type, // load error abort
          pathName: this.log.url,
          status: status + "-" + statusText,
          duration,
          params: body || "",
        });
      };
      this.addEventListener("load", handler("load"), false);
      this.addEventListener("error", handler("error"), false);
      this.addEventListener("abort", handler("abort"), false);
    }
    return oldSend.apply(this, arguments);
  };
}

/**
 * 重写 fetch  的 fetch 方法
 * 添加事件监听器，用于在请求的不同阶段触发对应的事件处理函数，
 * 对请求的状态、持续时间、响应数据等进行记录和上报.
 */
export function injectFetch() {
  // 保存原始的fetch方法
  var fetchOld = fetch;
  // 重写fetch方法，添加拦截器功能
  fetch = function (url, opts) {
    let startTime = Date.now(); // 发送前时间
    let log = {
      pathName: url,
      params: (opts && opts.body) || "",
    };
    // 执行原始的fetch方法
    return fetchOld(url, opts).then(
      (res) => {
        // 克隆一份，防止被标记已消费
        const tempRes = res.clone();
        let duration = Date.now() - startTime; // 持续时间
        let status = tempRes.status;
        let statusText = tempRes.statusText;
        // 请求成功不上报
        if (status == 200 || status == 204) return res;
        if (Date.now() - options.apiSending < 3000) return res;
        // 获取 response 并上报
        tempRes.text().then((data) => {
          tracker.send({
            type: EVENTTYPES.FETCH,
            errorType: ERRORTYPES.FETCH_ERROR,
            eventType: tempRes.type,
            status: status + "-" + statusText,
            duration,
            ...log,
          });
        });
        return res;
      },
      (err) => {
        let duration = Date.now() - startTime; // 持续时间
        tracker.send({
          type: EVENTTYPES.FETCH,
          errorType: ERRORTYPES.FETCH_ERROR,
          eventType: "catch",
          duration,
          response: err.message,
          ...log,
        });
        throw err;
      }
    );
  };
}
